import PropTypes from 'prop-types';
import { useState } from 'react';
import { isValidationBasedOnType } from '../../utils/common';
import { VALID_FIRST_NAME } from '../../utils/constant';

const FirstNameForm = ({ element, handleChange }) => {
  const [showError, setShowError] = useState('');

  const handleClick = (event) => {
    const question = { ...element, userInput: event.target.value, eligibleErr: true };
    if (question.isEligibal) {
      const eligVal = question.eligibleValues.split(',');
      if (eligVal?.includes(question?.userInput)) {
        question.eligibleErr = false;
      }
    }
    if (element?.isRequired) {
      if (event.target.value === '') {
        question.validationError = true;
      }
    } else {
      question.validationError = false;
    }
    if (question?.isRequired) {
      if (isValidationBasedOnType(question?.userInput, 'alphanumeric')) {
        setShowError('');
        question.validationError = false;
      } else {
        setShowError(VALID_FIRST_NAME);
        question.validationError = true;
      }
    } else {
      setShowError('');
      question.validationError = false;
    }
    handleChange(event, question);
  };

  return (
    <div>
      <div className="w-100">
        <input
          type="text"
          name={element?.question}
          value={element?.userInput || ''}
          className="form-control fs-13 answer inputText"
          placeholder={element?.placeholder}
          onChange={handleClick}
        />
        <span className="text-danger fs-12">{showError !== '' && showError}</span>
      </div>
    </div>
  );
};

FirstNameForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};
export default FirstNameForm;
